/* eslint-disable @appcues/jsx-props-no-spreading */
import React from 'react';
import { ConditionsShape } from '@studio/conditions';

import ChecklistCondition from './ChecklistCondition';
import FlowCondition from './FlowCondition';
import LanguageCondition from './LanguageCondition';
import SegmentCondition from './SegmentCondition';
import { DomainCondition } from './DomainCondition';
import { EventCondition } from './EventCondition';
import { GroupCondition } from './GroupCondition';
import { PropertyCondition } from './PropertyCondition';
import { UrlCondition } from './UrlCondition';
import { VersionCondition } from './VersionCondition';
import PinCondition from './PinCondition';
import MobileFlowCondition from './MobileFlowCondition';
import BannerCondition from './BannerCondition';
import { OrCondition, AndCondition, SubGroup } from './styled';

const SUB_CONDITIONS = {
  checklists: ChecklistCondition,
  content: FlowCondition,
  domains: DomainCondition,
  event: EventCondition,
  groups: GroupCondition,
  languages: LanguageCondition,
  properties: PropertyCondition,
  segments: SegmentCondition,
  url: UrlCondition,
  version: VersionCondition,
  pins: PinCondition,
  mobile: MobileFlowCondition,
  banners: BannerCondition,
};

const CONDITION_TYPE = {
  or: OrCondition,
  and: AndCondition,
};

export const ReadableConditions = ({ conditions, ...props }) => {
  const [[type, subConditions]] = Object.entries(conditions);

  if (['and', 'or'].includes(type)) {
    return conditions[type].flatMap((clause, c) => {
      const ConditionType = CONDITION_TYPE[type];
      return [
        // eslint-disable-next-line react/no-array-index-key
        <SubGroup key={c}>
          <ReadableConditions conditions={clause} {...props} />
        </SubGroup>,
        ...(c < subConditions.length - 1
          ? [<ConditionType>{type}</ConditionType>]
          : []),
      ];
    });
  }

  if (type === 'not') {
    const [[subConditionType, negatedCondition]] = Object.entries(
      subConditions[0]
    );

    const conditionType = negatedCondition?.type || subConditionType;

    const SubCondition = SUB_CONDITIONS[conditionType];

    return <SubCondition negated {...negatedCondition} {...props} />;
  }

  const conditionType = subConditions?.type || type;

  const SubCondition = SUB_CONDITIONS[conditionType];

  return <SubCondition {...subConditions} {...props} />;
};

ReadableConditions.propTypes = {
  conditions: ConditionsShape,
};

export default ReadableConditions;
